module.exports = require("vuetify/lib/components/VSelect");